import React from 'react';
import { useForm  } from '../hooks';
import hoistNonReactStatic from 'hoist-non-react-statics';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

const withForm = (WrappedComponent, initialValue) => {

  const WithFormComponent =  (props) => {
    
    const [value, { onChange, onAddToList, onSwitch, onChangeNumber, onSetForm }] = useForm(initialValue)
    
    return (
      <WrappedComponent 
        value={value}
        onChange={onChange}
        onAddToList={props.onAddToList || onAddToList}
        onSwitch={props.onSwitch || onSwitch}
        onChangeNumber={props.onChangeNumber || onChangeNumber}
        onSetForm={props.onSetForm || onSetForm}
        useForm={useForm}
        {...props}
      />
    )
  }
  
  WithFormComponent.displayName = `WithFormComponent(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatic(WithFormComponent, WrappedComponent);
  return WithFormComponent
}

export default withForm;